import { findKey } from 'lodash';

export const getEnumKeyByValue = <T extends Record<string, string>>(
  enumObj: T,
  value: string,
): keyof T | undefined =>
  findKey(enumObj, v => v === value) as keyof T | undefined;
